import { getRootConfigByLang } from '@/config/index'
import { getModules, updateAppConfigByLang } from '@/utils'
import store from '../store'

const Layout = () => import('@/components/Layout')
const Content = () => import('@/components/Content')
const NotFound = () => import('@/components/NotFound')

const lang = store.getters.currentLang
const modules = getModules('en-US')
const rootConfig = getRootConfigByLang(lang)

updateAppConfigByLang(lang)

const routes = [{
  path: '/',
  redirect: '/en-us/swapV2/changelog',
}]

modules.forEach(module => {
  const config = rootConfig[module.name]
  const route = {
    path: module.path,
    component: Layout,
    redirect: `${module.path}/changelog`,
    meta: {
      module: module.name,
    }
  }
  
  const children = []
  if(Array.isArray(config)) {
    config.forEach(item => {
      const root = item.path
      if(Array.isArray(item.children)) {
        item.children.forEach(child => {
          children.push({
            path: `${root}/${child.path}`,
            component: Content,
            meta: {
              module: module.name,
              title: child.name,
            }
          })
        })
      } else {
        children.push({
          path: root,
          component: Content,
          meta: {
            module: module.name,
            title: item.name,
          }
        })
      }
    })
    route.children = children
    routes.push(route)
  }
})

routes.push({
  path: '*',
  component: NotFound,
})

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js